import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import ActionButton from '../../../../../components/ActionButton/ActionButton';

import { getString } from '../../../../../helpers/stringHelpers.js';
import Replace from '../../../../../components/Replace/Replace';
import ContentRow from '../../../../../components/ContentRow/ContentRow.js';

import theme from '../../../../../theme.js';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'consentedPersons';

const TRUNCATE_LENGTH_MOBILE = 30;
const TRUNCATE_LENGTH = 80;

class ConsentedPersonsCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.toggleExpanded = this.toggleExpanded.bind(this);
  }

  toggleExpanded() {
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  render() {
    const { classes, details, removeAction, showUpdating, canEdit } =
      this.props;

    const { expanded } = this.state;

    const readMoreButtonText = expanded
      ? getString(stringsComponent, 'READ_LESS')
      : getString(stringsComponent, 'READ_MORE');
    const ReadMoreButtonIcon = expanded
      ? KeyboardArrowUpIcon
      : KeyboardArrowDownIcon;
    const truncateLength =
      window.innerWidth < theme.breakpoints.values.sm
        ? TRUNCATE_LENGTH_MOBILE
        : TRUNCATE_LENGTH;
    const readMoreButton =
      details.length > truncateLength ? (
        <a
          className={classes.readMoreButton}
          onClick={(e) => {
            this.toggleExpanded();
            e.preventDefault();
          }}
          href='#'
        >
          {readMoreButtonText}
          <ReadMoreButtonIcon className={classes.readMoreButtonIcon} />
        </a>
      ) : null;

    let displayDetails =
      expanded || details.length <= truncateLength
        ? details
        : details.substr(0, truncateLength) + '...';

    displayDetails = (
      <Replace
        content={displayDetails}
        toReplace='0800 801 601'
        replaceWith={
          <a className={classes.link} href='tel:0800 801 601'>
            0800 801 601
          </a>
        }
      />
    );

    return (
      <div className={classes.root}>
        <Grid container spacing={16}>
          <Grid item xs={12}>
            <div className={classes.iconFieldWrapper}>
              <div className={classes.iconLabelWrapper}>
                <PersonOutlinedIcon className={`${classes.icon} ItemIcon`} />
                <Typography
                  className={`${classes.label} ${classes.labelMobile}`}
                >
                  {getString(stringsComponent, 'DETAILS')}
                </Typography>
              </div>
              <div className={classes.detailsWrapper}>
                <Typography
                  className={`${classes.label} ${classes.labelDesktop}`}
                >
                  {getString(stringsComponent, 'DETAILS')}
                </Typography>
                <ContentRow customClass={classes.contentRow}>
                  <div className={classes.content}>
                    <Typography className={classes.value}>
                      {displayDetails}
                    </Typography>
                    <div>{readMoreButton}</div>
                  </div>
                  {canEdit && (
                    <div className={classes.actions}>
                      {showUpdating ? (
                        <Typography className={classes.updating}>
                          {getString('contactDetails', 'UPDATING_TEXT')}
                        </Typography>
                      ) : (
                        <ActionButton
                          icon={DeleteOutlineIcon}
                          action={() => removeAction()}
                          label='Remove'
                          withBorder={true}
                        />
                      )}
                    </div>
                  )}
                </ContentRow>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

ConsentedPersonsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

ConsentedPersonsCard.defaultProps = {};

export default withStyles(styles, { withTheme: true })(ConsentedPersonsCard);
